import { Controller } from '@hotwired/stimulus';
import Vue from 'vue';
import { getPreviewUrl } from 'manage/utils/getPreviewUrl';

export default class extends Controller {
  static targets = ['custom', 'template'];
  static values = { data: Object };

  connect() {
    const el = this.templateTarget;
    const { icon, header, banner } = this.dataValue;
    const customs = {};

    for (const custom of this.customTargets) {
      customs[custom.dataset.id] = custom.dataset.image || '';
    }

    new Vue({
      el,
      data: {
        icon,
        header,
        banner,
        customs,
      },
      methods: {
        onChangeIcon(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.icon = url;
          });
        },
        onChangeHeader(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.header = url;
          });
        },
        onChangeBanner(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.banner = url;
          });
        },
        onChangeCustom(e, id) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.customs = Object.assign({}, this.customs, { [id]: url });
          });
        },
      },
    });
  }
}
